import { useMemo } from "react";

export function useTrailingDateRange(days: number) {
  return useMemo(() => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    const pad = (d: Date) => d.toISOString().split("T")[0];
    return { startDate: pad(start), endDate: pad(end) };
  }, [days]);
}
